/** @jsxImportSource solid-js */
import { Show, type JSX } from "solid-js";
import { useWidgetStore } from "../hooks/widget-context";

export function WidgetScrim(): JSX.Element {
  const store = useWidgetStore();
  return (
    <Show when={store.commentMode()}>
      {/* Decorative only: pointer events must fall through to the page, or no
          element can be hovered or picked. The crosshair lives on the page root
          instead (the scrim never receives the pointer, so a cursor here would
          never show). Edge vignette rather than a full-body tint - the middle
          of the page stays untouched so the content under review reads true. */}
      <div
        data-pl-scrim=""
        class="z-pl-under pointer-events-none fixed inset-0 [box-shadow:inset_0_0_80px_12px_oklch(0.546_0.215_262/0.24)]"
      />
    </Show>
  );
}
